import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { IsPastDatePipeModule } from '@main-client/src/app/pipes/is-past-date-pipe/is-past-date-pipe.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';
import { SignUpBannerModule } from '@main-client/src/app/sign-up-banner/sign-up-banner.module';

import { OpportunityBackend } from '@libs/src/opportunity/opportunity.backend';

import { SignUpEventBannerComponent } from './sign-up-event-banner.component';

@NgModule({
  declarations: [SignUpEventBannerComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    IsPastDatePipeModule,
    ProgressSpinnerModule,
    SignUpBannerModule,
  ],
  exports: [SignUpEventBannerComponent],
  providers: [DatePipe, OpportunityBackend],
})
export class SignUpEventBannerModule {}
